import React, {PureComponent, Fragment} from 'react'
import PropTypes from 'prop-types'
export class ReadOnly extends PureComponent{
  static propTypes = {
    on: PropTypes.bool
  }

  hasMember = (elm) => {
    if (!elm || !elm.props)
      return false

    if (elm.props.member)
      return true

    return (React.Children.map(elm.props.children, child => this.hasMember(child)) || []).some(c => c)
  }

  mapAndKeepStructure(children, mapper) {
    const newChildren = React.Children.map(children, mapper)
    return (Array.isArray(newChildren) && !Array.isArray(children)) ? newChildren[0] : newChildren
  }

  renderChildren = (children) =>
    (!this.props.on || !children) ? children : this.mapAndKeepStructure(children, child => {
      if(!this.hasMember(child)) {
        return child
      } else {
        let children = this.renderChildren(child.props.children)
        let disabled = (child.props.member) ? { disabled: true } : {}
        return React.cloneElement(child, {children, ...disabled})
      }
    })

  render = () =>
    <Fragment>
      {this.renderChildren(this.props.children)}
    </Fragment>

}

export default ReadOnly